import React, { useEffect } from 'react';
import { Header, Sidebar, Footer, MainContent } from './layout';
import { useDispatch, useSelector } from 'react-redux';
import Login from './pages/Auth/Login';
import { useNavigate } from 'react-router-dom';
import authApi from './api/auth/auth.api';
import * as auth from './services/auth/auth.service';

function App() {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isAuthenticated) {
            (async function () {
                //need to get the csrf and pass it to axios req config first before making any api call as sanctum uses `web` as its default guard (check at config/sanctum.php)
                await authApi.getCsrf();
            })();

            auth.logoutFE(dispatch, navigate);
        }
    }, []);

    return (
        <>
            {isAuthenticated ? (
                <>
                    <Header />
                    <Sidebar />
                    <MainContent />
                    <Footer />
                </>
            ) : (
                <Login />
            )}
        </>
    );
}

export default App;
